<template>
  <q-page class="bg-black q-px-sm text-white">
    <router-link :to="{name: 'mobileDrinksList', params: {idSeance: idSeance}}">
      <q-btn outline label="RETOUR" type="button" color="grey-3" size="sm" class="q-mt-lg q-mb-xl"/>
    </router-link>
    <div class="row justify-between">
      <span class="text-h5 text-weight-bold">
        <template v-if="drink">
          {{drink.name}}
        </template>
      </span>
      <div>
        <div class="row items-center justify-end">
          <span class="q-mr-sm">Prix : </span>
          <span class="text-weight-bold text-h6">
            <template v-if="drink">{{Number.parseFloat(drink.optimized_price).toFixed(2)}}</template>€
          </span>
        </div>
        <div class="row items-center">
          <span class="q-mr-sm text-caption">Différence dernier prix : </span>
          <span :class="[difference <= 0.00 ? 'text-green' : 'text-red']">
            <template v-if="difference > 0">
              +
            </template>
            {{difference.toFixed(2)}}€
          </span>
        </div>
      </div>
    </div>
    <div>
      <div class="row items-center q-pb-md q-pt-md">
        <p class="q-pr-md q-pl-md">Fluctuation du prix dans la soirée</p>
        <div class="gradient q-ml-md"></div>
      </div>
    </div>
    <ChartLine :data="datas" :labels="labels" v-if="printChart"/>
    <div class="q-pl-md q-pb-xl">
      <div class="row items-center q-pb-xs q-pt-sm">
        <p class="q-pr-md">Catégorie</p>
        <div class="gradient q-ml-md"></div>
      </div>
      <template v-if="drink">
        <p class="text-caption">- {{ drink.category.name }}</p>
      </template>
    </div>
  </q-page>
</template>

<script>

import ReconnectingEventSource from "reconnecting-eventsource";
import { getAnonymousDataForDrink, getPriceHistoriesAnonymousByDrink } from '~/services/drinks';
import { getAnonymousSeanceById } from '~/services/seances';
import { round } from '~/services/functions';
import { baseUrl, base_url_seances } from '~/variables';
import CategoryMobile from '../components/CategoryMobile.vue';
import DrinkMobile from '../components/DrinkMobile.vue';
import ChartLine from '../components/ChartLine.vue'

export default {
  name: "mobileDrinks",
  components: {
    CategoryMobile,
    DrinkMobile,
    ChartLine
  },
  data() {
    return {
      idSeance: null,
      showKrackDialog: false,
      startKrack: true,
      series: [],
      esSeance: null,
      datas: [],
      labels: [],
      printChart: false,
      drink: null
    };
  },  
  async created() {
    this.idSeance = parseInt(this.$route.params.idSeance);
    this.idDrink = parseInt(this.$route.params.idDrink)
    let response = await getAnonymousSeanceById(this.idSeance);
    if (response.status == 200) {
      this.seance = response.data;
    }

    response = await getAnonymousDataForDrink(this.idSeance, this.idDrink);
    if (response.status == 200) {
      this.drink = response.data;
    }

    response = await getPriceHistoriesAnonymousByDrink(this.idDrink);
    if (response.status === 200) {
      this.series = response.data
      this.series.forEach(element => {
        this.datas.push(element.price)
        this.labels.push(element.time)
      });
      this.printChart = true

    }
  },
  mounted() {
    this.setupStream();
  },
  destroyed () {
    this.esSeance.close()
  },
  methods: {
    setupStream() {
      // Not a real URL, just using for demo purposes
      this.esSeance = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.idSeance}/events/`);
      // this.esDrink = 

      this.esSeance.addEventListener('command', event => {
        let data = JSON.parse(event.data);
        const prices = data.consommation_set.map(e => e.price * e.quantite)
        let price = prices.reduce((accumulator, currentValue) => accumulator + currentValue);
        price = Number.parseFloat(price).toFixed(2);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: `Nouvelle commande: ${price} € `,
          position: 'top-right',
        });
      }, false);
      this.esSeance.addEventListener('update', event => {
        const data = JSON.parse(event.data);
        data.map( e => {
          //si le drink est le drink courant
          if (e.drink.id === this.idDrink) {
            this.datas.push(e.drink.current_price)
            this.labels.push(e.time)
            this.drink.optimized_price = e.drink.optimized_price
          }
          //ajout du prix actuel au graph
          //calcul de la différence
          // Récupération de l'index de la boisson qu'on va traiter
        });
      }, false);
      this.esSeance.addEventListener('krach_start', event => {
        this.startKrack = true;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
      this.esSeance.addEventListener('krach_stop', event => {
        this.startKrack = false;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
    },
    toggleKrackDialog() {
      this.showKrackDialog = !this.showKrackDialog;
    }
  },
  computed: {
    difference() {
      let dif = 0.00
      if(this.datas.length > 1) {
        // récupération des 2 derniers élements du tableau
        const test = this.datas.slice(-2)
        const first = round(test[0])
        const second = round(test[1])
        //second - first = difference ex : 4.00 - 4.10 = -10
        dif = Number.parseFloat(second-first)
      } else {
        dif = Number.parseFloat(0)
      }
      return dif
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
a {
  text-decoration: none; 
}
</style>